import UsersManagement from '../sections/usersManagement/UsersManagement';
import { useAdminToast } from '../shell/AdminToastContext';

export const GestionUsuariosPage = () => {
    const toast = useAdminToast();
    return <UsersManagement toast={toast} />;
};

export default GestionUsuariosPage;
